import React from "react";
import "./NotStartedProgrammeCard.scss";

import { Link } from "react-router-dom";
import marked from "marked";
import { Card, CardContent, CardMedia } from "@material-ui/core";
import { Button } from "@thrivetribe/gloji.ui.atoms.button";

const MarkedDownContent = ({ content }) => {
  return <div dangerouslySetInnerHTML={{ __html: marked(content) }}></div>;
};

interface ProgrammeOverview {
  programmeId: string;
  primaryButtonUrl: string;
  primaryButtonText: string;
  secondaryButtonUrl: string;
  programmeTitle: string;
  cardTitle: string;
  description: string;
  imgUrl: string;
  imgTitle: string;
}

interface Props {
  imgUrl: string;
  programmeOverview: ProgrammeOverview;
}

const NotStartedProgrammeCard: React.FC<Props> = ({ programmeOverview, imgUrl }: Props) => {
  const { primaryButtonUrl, primaryButtonText, cardTitle, description, imgTitle } = programmeOverview;

  return (
    <Card className={`new-programme-card`} elevation={0}>
      <CardMedia className={`new-programme-card__image`} image={imgUrl} title={imgTitle}></CardMedia>
      <CardContent className={`new-programme-card__content`}>
        <div>
          <h3 className={"new-programme-card__header--title"}>{cardTitle}</h3>
          <MarkedDownContent content={description} />
        </div>
        <Link
          to={primaryButtonUrl}
          className="programme-card__container-link"
          aria-label="Current Step"
          id={"lets-get-started-button"}
        >
          <Button className="programme-card__button" tabIndex="-1" color="primary">
            {primaryButtonText}
          </Button>
        </Link>
      </CardContent>
    </Card>
  );
};

export default NotStartedProgrammeCard;
